/* eslint-disable @typescript-eslint/no-explicit-any */
import { ICellEditorParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { UserRef } from '../schema/schema.interface';
import { AddressStoreModel } from '../store/address/address.store';
import { MachineStoreModel } from '../store/machine/machine.store';
import { ColumnDefinition } from '@res/ngg-core';
export const transactionTipValueGetter = (params: Partial<ValueGetterParams>) =>
  params.data.selectedTip >= 0
    ? params.data.tips[params.data.selectedTip][
        params.data.paymentDetails.paymentName === '"Bank Card"' ? 'cardAmount' : 'cashAmount'
      ] / 1000
    : 0;

/*
**Szűrés BASIC nézet:**
- CID - szöveges keresés + lista választó
- Cég neve - szöveges keresés + lista választó
- Telephely - szöveges keresés + lista választó
- Fizetési mód - többszörös Check box (előre definiált értékek)
- Fizetési eredmény - többszörös Check box (előre definiált értékek)
- Borravaló - szám adat megadása (kisebb vagy nagyobb)
- Teljes összeg (borravaló + összeg) - szám adat megadása (kisebb vagy nagyobb)
- Dátum - Időtartomány (év, hónap, nap: óra, perc) - Erről írok lent is, kérlek egyeztessünk, hogy a gyorsfilteres megoldás nem-e bonyolult.
*/
export const transactionBaseSchema: ColumnDefinition[] = [
  {
    id: 'cId',
    name: 'cId',
    // filter: true,
    colDef: {
      minWidth: 90,
      filter: true,
      width: 90,
      maxWidth: 150,
      valueGetter: ({ context, data }: ValueGetterParams) => {
        return (((context ?? data.context).machineStore as any).machines() as MachineStoreModel[]).find(
          (x) => x.ref.id === data?.belongsTo.id,
        )?.cId;
      },
      filterParams: {
        values: (params: any) => {
          params.success(
            (((params?.context ?? params?.data?.context)?.machineStore as any).machines() as MachineStoreModel[])
              .filter((x) => x.cId)
              .map((x) => x.cId),
          );
        },
      },
    },
  },
  {
    id: 'userId',
    name: 'userId',
    filter: true,
    type: 'dropdown',
    colDef: {
      minWidth: 100,
      width: 100,
      maxWidth: 200,

      filter: false,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: (params: ICellEditorParams) => [
          ...((params.context ?? params.data.context).userStore as any).users().map((x: { ref: UserRef }) => x.ref),
          null,
        ],
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const formattedvalue = ((params.context ?? params.data.context).userStore as any).users();

        const findValue = formattedvalue.find((x: { ref: UserRef }) => x.ref.id === params.value?.id)?.companyName;
        return findValue ?? '';
      },
      valueGetter: (params: ValueGetterParams) => {
        return params.data.userId;
      },
      filterParams: {
        values: (params: any) => {
          const users =
            params.context.userStore?.users().map((x: { ref: UserRef; companyName: string }) => x.ref) ?? [];
          params.success(users);
        },

        valueFormatter: (params: ValueFormatterParams) => {
          const formattedvalue =
            ((params.context ?? params.data.context).userStore as any)
              .users()
              .find((x: { ref: UserRef }) => x.ref === params.value)?.companyName ?? 'Nincs megadva';
          return formattedvalue;
        },
      },
    },
    dropdownValues: { dropdownCollectionField: 'users/companyName' },
  },
  {
    id: 'addressId',
    name: 'addressId',
    type: 'dropdownGroup',
    filter: true,
    colDef: {
      minWidth: 100,
      width: 100,
      maxWidth: 200,
      // cellDataType: 'object',
      filter: true,
      // valueFormatter: ({ context, data, value }: ValueFormatterParams) => {
      //   const allAddresses = ((context ?? data.context).addressStore as any).addresses();
      //   const currentMachine = ((context ?? data.context).machineStore as any)
      //     .machines()
      //     .find((x: { ref: MachineRef }) => x.ref.id === value?.id)?.addressId.ref;
      //   return allAddresses.find((x: { ref: AddressRef }) => x.ref.id === currentMachine?.id).addressName ?? '';
      // },
      valueGetter: ({ context, data }: ValueGetterParams) => {
        const allAddresses = ((context ?? data.context).addressStore as any).addresses() as AddressStoreModel[];
        const currentMachine = (((context ?? data.context).machineStore as any).machines() as MachineStoreModel[]).find(
          (x) => x.ref.id === data?.belongsTo.id,
        )?.addressId;
        return allAddresses.find((x) => x.ref.id === currentMachine?.id);
      },
      filterParams: {
        values: (params: any) => {
          params.success(
            (params.context.addressStore?.addresses() as AddressStoreModel[]).map((x) => ({
              addressName: x.addressName,
              value: x.ref,
            })) ?? [],
          );
        },
      },
      valueFormatter: (params: ValueFormatterParams) => params.value?.addressName,
    },
  },
  {
    id: 'paymentDetails.paymentName',
    name: 'paymentType',
    type: 'dropdown',
    filter: true,
    colDef: {
      width: 100,
      maxWidth: 160,
      valueFormatter: (params: ValueFormatterParams) => params.data?.paymentDetails?.paymentName ?? '',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ['Bank Card', '', 'Szép Card', 'Cash'],
      },
    },
  },
  {
    id: 'partialPayment',
    name: 'partialPayment',
    // type: 'boolean',
    filter: true,
    colDef: {
      width: 100,
      maxWidth: 160,
    },
  },
  {
    id: 'paymentResult',
    name: 'result',
    type: 'dropdown',
    filter: true,
    colDef: {
      width: 100,
      maxWidth: 160,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ['Successful', 'Abandoned', 'Cancelled', 'Failed', 'FullyRefunded', 'InProcess', 'PartiallyRefunded'],
      },
    },
  },
  {
    id: 'tip',
    filter: true,
    name: 'tip',
    colDef: {
      width: 100,
      maxWidth: 150,
      type: 'rightAligned',
      cellDataType: 'number',
      valueGetter: (params: ValueGetterParams) =>
        params.data.selectedTip >= 0
          ? (params.data?.paymentDetails.paidAmount - params.data?.paymentDetails.originalAmount) / 1000
          : 0,

      valueFormatter: (params: ValueFormatterParams<any, number>): string => (params?.value ?? 0).toLocaleString(),
    },
  },
  {
    id: 'paymentDetails.paidAmount',
    name: 'fullAmount',
    filter: true,
    colDef: {
      width: 100,
      maxWidth: 150,
      type: 'rightAligned',
      cellDataType: 'number',
      filter: 'agNumberColumnFilter',
      cellStyle: { fontWeight: 'bold' },
      valueGetter: (params: ValueGetterParams) =>
        params.data?.paymentDetails?.paidAmount ? params.data?.paymentDetails.paidAmount / 1000 : 0,
      valueFormatter: (params: ValueFormatterParams<any, number>): string =>
        params.value == null ? '0' : params?.value?.toLocaleString(),
    },
  },
  {
    id: 'createdAt',
    name: 'creationDate',
    type: 'datepicker',
    isDateTime: true,
    filter: true,
    colDef: {
      width: 200,
      minWidth: 100,
      maxWidth: 200,
      cellDataType: 'date',
      filter: 'agDateColumnFilter',
      valueFormatter: (params: ValueFormatterParams<any, Date>): string =>
        (params?.value === null || params?.value === undefined || params?.value?.toString() === 'Invalid Date'
          ? new Date()
          : params.value
        ).toLocaleString(undefined, { hour12: false }),
    },
  },
];
export const transactionAdminSchema: ColumnDefinition[] = [
  // { id: 'id', name: 'id' },
  ...transactionBaseSchema,
  // {
  //   id: 'userId',
  //   name: 'userId',
  //   type: 'dropdown',
  //   dropdownValues: { dropdownCollectionField: 'users/companyName', addEmpty: true },
  // },
  // {
  //   id: 'addressId',
  //   name: 'addressId',
  //   type: 'dropdownGroup',
  //   dropdownValues: {
  //     dropdownCollectionField: 'addresses/addressName',
  //     parentCollectionField: 'users/companyName',
  //     addEmpty: true,
  //     isReference: true,
  //   },
  // },
];
